import { UnitStatus } from '~/providers/types/unit';
import { Profile } from './userProfile';

const ADMIN_PERMISSIONS = ['[C]', '[CP]'] as const;

const santanderIds = new Set([21, 59, 120, 152]);

export const hasMultipleSantanderPermissions = (profile: Profile): boolean => !!profile.manageMultipleClients
  && profile.permissions.PER_CLIENT.length > 1
  && profile.permissions.PER_CLIENT.every((client) => santanderIds.has(client.clientId));

const isAdminConta = (profile: Profile, clientId: number): boolean => !!profile.permissions.isAdminConta && !!profile.permissions.CLIENT_MANAGE.includes(clientId);

export const verifyProfileCanManageProgramming = (
  profile: Profile,
  clientId?: number,
  unitId?: number,
): boolean => !!(
  profile.permissions.isInstaller
  || profile.manageAllClients
  || (clientId !== undefined && (profile.adminClientProg?.CLIENT_MANAGE.includes(clientId) || isAdminConta(profile, clientId)))
  || (unitId !== undefined && profile.adminClientProg?.UNIT_MANAGE.includes(unitId)));

export const canManageScheduleProgramming = (
  profile: Profile,
  production?: number,
  clientId?: number,
  unitId?: number,
): boolean => {
  const isInstallerOnInstallationUnit = profile.permissions.isInstaller
    && [UnitStatus.INSTALLATION, UnitStatus.MODERNIZATION].includes(String(production) as UnitStatus);

  return !!(
    profile.manageAllClients
    || isInstallerOnInstallationUnit
    || (clientId !== undefined && profile.adminClientProg?.CLIENT_MANAGE.includes(clientId))
    || (unitId !== undefined && profile.adminClientProg?.UNIT_MANAGE.includes(unitId))
    || (profile.permissions.isAdminConta && clientId !== undefined && profile.permissions.CLIENT_MANAGE.includes(clientId))
  );
};

export const isAdminByUnit = (
  profile: Profile,
  unitId: number,
): boolean => profile.permissions.PER_UNIT?.some(
  (item) => item.units.includes(unitId) && ADMIN_PERMISSIONS.some((p) => item.p.includes(p)),
) ?? false;
